import { Skeleton } from 'primereact/skeleton';
import classes from './loadingSkeleton.module.scss';

const TMSTableLoadingSkeleton = () => {
  return (
    <div className={classes.tabSkeletonSkeleton}>
      <div className={classes.tabSkeletonTable}>
        <Skeleton height="45rem"></Skeleton>
      </div>
    </div>
  );
};

export default TMSTableLoadingSkeleton;
